var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesGreenSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 196,
    viewBox: "0 0 193 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193 0L175.855 72.1117H193V0ZM134.545 85.4233L166.712 73.745L125.973 11.8417L134.545 85.4233ZM126.462 90.0783L67.0275 45.8967L100.256 112.128L126.462 90.0783ZM94.2957 119.233L23.3494 98L77.2326 148.878L94.2957 119.233ZM73.967 157.617L0 161.945L68.0072 191.345L73.967 157.617ZM89.0706 196H193V92.0383C135.606 92.0383 89.0706 138.588 89.0706 196Z",
    fill: "#8FD3AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesGreenSun);
export default __webpack_public_path__ + "static/media/StoriesGreenSun.8fd461958af0225672161becc2e9b009.svg";
export { ForwardRef as ReactComponent };